var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppSubHeader',{attrs:{"link":"contratos","title":"Mi paz y salvo"}}),_c('main',{staticClass:"m-content container mb-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 mx-auto"},[_c('pazysalvoVue')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }